"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("path");
const processCwd = process.cwd();
const addProcessCwd = globPath => `${globPath[0] === '!' ? '!' : ''}${path_1.join(processCwd, globPath.replace(/^!/, ''))}`;
exports.globals = {
    typescript: require('../tsconfig.json').compilerOptions,
    babel: {
        babelrc: false,
        extends: path_1.join(__dirname, '../.babelrc')
    },
    sourceFiles: []
        .concat([
        'bin/**/*.js',
        'src/**/*.+(js|ts|tsx)',
        'gulp/**/*.js',
        'gulpfile.js'
    ].map(addProcessCwd))
        .concat([
        '!**/+(node_modules|bower_components)/**/*',
        '!**/*.min.js',
    ])
};
